import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { KineticLines } from "../motion";

const PageHeader = ({ eyebrow, titleLines, subtitle, crumb }) => {
  return (
    <section className="relative overflow-hidden bg-ink pt-36 pb-20 grain sm:pt-44 sm:pb-24" data-testid="page-header">
      <div className="blueprint-grid absolute inset-0 opacity-50" />
      <div className="spotlight absolute inset-0" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mb-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40"
        >
          <Link to="/" className="hover:text-white">Home</Link>
          <span>/</span>
          <span className="text-brand-soft">{crumb || eyebrow}</span>
        </motion.div>

        {eyebrow && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.15 }}
            className="mb-5 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-brand-soft"
          >
            <span className="h-px w-10 bg-brand-soft" />
            {eyebrow}
          </motion.div>
        )}

        <h1 className="font-display text-5xl font-semibold leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-7xl">
          <KineticLines lines={titleLines} delay={0.25} />
        </h1>

        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="mt-7 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
